import React from 'react';

import DateFormatter from './DateFormatter';
import NumericFormatter from './NumericFormatter';

const AttributeFormatter = (props) => {
  const { rowData } = props.dependentValues;
  let attribute;
  if (rowData && rowData.attributeConfig) {
    attribute = props.dependentValues.rowData.attributeConfig;
  } else {
    return <div />;
  }

  switch (attribute.attributeType) {
    case 'NUMERIC':
      return <NumericFormatter {...props} align="left" value={rowData.doubleValue} />;
    case 'INTEGER':
      return <NumericFormatter {...props} type="integer" align="left" value={rowData.integerValue} />;
    case 'DATE':
      return <DateFormatter {...props} value={rowData.dateValue} />;
    case 'REFERENCE':
      const description = rowData.referenceValue && rowData.referenceValue.description;
      return <div title={description}>{description}</div>;
    default:
      return <div title={rowData.textValue}>{rowData.textValue}</div>;
  }
};

export default AttributeFormatter;
